<template>
  <div>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="分类名称">
            <a-input v-model.trim="searchForm.name" placeholder="请输入分类名称" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <a-button type="primary" icon="plus-circle" @click="handleAddTag">添加分类</a-button>
      <div class="flex ml20" style="margin-top: 4px">
        <a-button type="primary" icon="search" style="margin-right:10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :loading="loading" :columns="columns" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="module_select" slot-scope="text, record">
        <div v-if="text === 1">
          <span style="margin-right:20px;" v-for="item in WORDS_MODULES" :key="item.key">{{ item.value }}</span>
        </div>
        <div v-else>
          <span style="margin-right:20px;" v-for="item in getModules(record.modules)" :key="item.key">{{ item.value }}</span>
        </div>
      </template>
      <template slot="operator" slot-scope="text, record">
        <div>
          <a-button type="link" size="small" style="margin-right:10px;" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button type="link" size="small" style="margin-right:10px;" @click="handleTableCommand('delete',record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 编辑标签 -->
    <a-modal v-model="visible" :title="title" :afterClose="handleCancel">
      <a-form-model ref="formDom" :rules="rules" :model="form" :label-col="{span: 4}" :wrapper-col="{span: 20}">
        <a-form-model-item label="分类名称" prop="name">
          <a-input v-model.trim="form.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="归属模块" prop="modules">
          <a-checkbox :checked="checkAll" :indeterminate="indeterminate" @change="onCheckAllChange">
            全选
          </a-checkbox>
          <br />
          <a-checkbox-group v-model="form.modules" @change="onChange">
            <a-row v-for="item in WORDS_MODULES" :key="item.key" :span="50">
              <a-col :span="50">
                <a-checkbox :value="item.key">
                  {{ item.value }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取 消
        </a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleSubmit">
          提 交
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { strategyCommand, title } from './business/tableLogic'
import { searchForm, columns, rules } from './business/tagList'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
import api from '@/api/'
import _ from 'lodash'

export default {
  setup() {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      // rules: {
      //   name: [ { required: true, message: '请首输入名称', trigger: 'change' } ],
      //   modules: [ { trigger: 'change', validator: function(rule, value, callback) {
      //     if (!_this.form.modules.length && !_this.checkAll) {
      //       callback(new Error('请选择归属模块'))
      //     } else {
      //       callback()
      //     }
      //   } } ]
      // },
      rules,
      columns, // 表头列表
      btnLoading: false, // 按钮loading
      title: title.Add, // 弹窗title
      form: { name: '', module_select: undefined, modules: [] },
      searchForm: { ...searchForm }, // 搜索表单
      wordTypeList: [], // 违禁词分类列表
      checkAll: false,
      indeterminate: false
    })

    onMounted(() => {
      methods.getList()
      methods.getWordType()
    })

    const methods = {
      getModules(record) {
        const arr = []
        _this.WORDS_MODULES.map(item => {
          record.map(items => {
            if (item.key === items) {
              arr.push(item)
            }
          })
        })
        return arr
      },
      // 是否全选
      onCheckAllChange(e) {
        if (e.target.checked) {
          this.form.modules = _this.WORDS_MODULES.map(item => item.key)
        } else {
          _this.form.modules = []
        }
        _this.indeterminate = false
        _this.checkAll = e.target.checked
      },

      onChange(checkedList) {
        this.indeterminate = !!checkedList.length && checkedList.length < _this.WORDS_MODULES.length
        this.checkAll = checkedList.length === _this.WORDS_MODULES.length
        this.$refs.formDom.validateField('modules', async valid => {})
      },

      search() {
        _this.pagination.current = 1
        this.getList()
      },

      // 验证
      valIdentify() {},

      // 获取分类
      async getWordType() {
        const res = await api.listTypeWord()
        state.wordTypeList = res.data.forbiddenWordsType
      },

      // 获取列表
      async getList() {
        _this.loading = true
        const res = await api.listTypeWord({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { forbiddenWordsType, pagination } = res.data
        _this.data = forbiddenWordsType
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      // 新增标签
      handleAddTag() {
        _this.visible = true
        _this.isEdit = false
        state.title = title.Add
      },

      // 关闭弹窗
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.checkAll = false
        _this.indeterminate = false
        _this.visible = false
        state.btnLoading = false
      },

      // 提交编辑
      async handleSubmit() {
        _this.$refs.formDom.validate(async valid => {
          if (valid) {
            const params = _.cloneDeep(state.form)
            if (_this.checkAll) {
              params.module_select = 1
              params.modules = []
            } else {
              params.module_select = 0
            }
            state.btnLoading = true
            let res
            if (_this.isEdit) {
              res = await api.updateTypeWord(params)
            } else {
              res = await api.createTypeWord(params)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '新增成功~')
              _this.visible = false
              methods.getList()
              methods.getWordList()
            }
            state.btnLoading = false
          }
        })
      },
      async getWordList() {
        await api.listWord({
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
      },

      // 清除
      handleClear() {
        state.searchForm = { ...searchForm }
        this.search()
      },

      // 表格操作
      handleTableCommand(type, data) {
        strategyCommand[type].call(_this, data)
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-tag {
  margin-right: 0;
}
</style>
